const humanizedKeyList = object => {
    if (!object) return "[null]";
    let keys = Object.keys(object).sort();
    if (keys.length === 0) return "[empty]";
    if (keys.length > 5) {
        keys = [
            ...keys.slice(0, 2),
            `…skip ${keys.length - 3}…`,
            keys[keys.length - 1],
        ];
    }
    return keys.join(", ");
};

export default humanizedKeyList;



// WEBPACK FOOTER //
// ./app/data/util/humanizedKeyList.js